import { useEffect, useState } from "react";
import LoadingScreen from "@components/content/LoadingScreen";
import { PrintPageDataLoadedPubSub } from "@utils/pubsubs/PubSub";
import { CategoryApi } from "@/api/CategoryApi";
import { ProductApi, ProductDataType } from "@/api/ProductsApi";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { roundCant } from "@utils/Cant";

type InventoryCategory = {
  title: string,
  products: ProductDataType[]
}

const InventoryReportExcel = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isReportExported, setReportExported] = useState<boolean>(false);

  useEffect(() => {
  }, []);

  useEffect(() => {
    PrintPageDataLoadedPubSub.publish({ dataLoaded: false })
    if (!isReportExported) {
      loadReportData()
    }
  }, [isReportExported]);

  const loadReportData = async () => {
    setIsLoading(true);
    try {
      const categories: InventoryCategory[] = []
      const categoryList = await CategoryApi.optionsList({ activo: { eq: true } });
      for (const categoryId in categoryList) {
        let nt = undefined;
        let products: ProductDataType[] = [];
        do {
          const { items, nextToken } = await ProductApi.fetchAllByCategory(categoryId, {}, `${nt || ""}`, 1000,
            ["codigo", "descripcion_fact", "temporal", "activo", "existencias", "costo"]
          )
          products = [
            ...products,
            ...(items.filter(p => !p.temporal && p.activo))
          ]
          nt = nextToken
        } while (nt)

        products.sort((a, b) => {
          const nameA = a.descripcion_fact || "";
          const nameB = b.descripcion_fact || "";

          return nameA.localeCompare(nameB, undefined, { sensitivity: "base" });
        })

        categories.push({
          title: categoryList[categoryId],
          products
        })
      }

      exportToExcel(categories);
    } finally {
      setIsLoading(false);
      setReportExported(true);
      PrintPageDataLoadedPubSub.publish({ dataLoaded: true })
    }
  }

  const exportToExcel = (categories: InventoryCategory[]) => {
    const headers = ["Codigo", "Descripcion", "Costo", "Existencias"];

    const detailRows = categories.flatMap((c) => {
      const categoryData = [c.title]

      const products = c.products.map(p => {
        let costo = Number(String(p.costo).replace(",", "."));
        isNaN(costo) ? p.costo : costo;
        return [
          p.codigo,
          p.descripcion_fact,
          costo,
          roundCant(Number(p.existencias || 0))
        ]
      });

      return [
        categoryData,
        ...products
      ]
    });

    const sheetDetail = XLSX.utils.aoa_to_sheet([headers, ...detailRows]);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, sheetDetail, "Detalle");

    const fileName = `inventario.xlsx`;

    const wbout = XLSX.write(wb, { type: "array", bookType: "xlsx" });
    const blob = new Blob([wbout], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, fileName);
  };

  return (
    <div>
      <LoadingScreen isLoading={isLoading} />
    </div>
  );
}

export default InventoryReportExcel;
